import { Messages } from '../../../../codegen/Localize';
import { IDataAlertInfo } from '../../../../ts/models/IDataAlertInfo';
import { dataAlertResume } from '../../../actions/spaces/DataAlertMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isAlertSuspended, isEditOrResumeEnabled } from './IEntityActionHelpers';

export const DataAlertResumeAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.Resume,
  translateName: Messages.resumeDataAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return isAlertSuspended(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[], state: AppState) => {
    return isEditOrResumeEnabled(state, targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertResume(targetItems)
};
